import React, { useLayoutEffect, useEffect, useRef } from 'react';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import DropDown from '../ui/react-ui/dropdown';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { getStatsGates } from '../../api/statsAPI';
import { setStatsGatesForXY, setStatsGatesXYSelected } from '../../redux/stats-dashboard';
var t = i18n.getFixedT(null, 'stats-dashboard');
var StatsGateXYChart = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$statsDas = _useSelector.statsDashboard,
      statsGatesForXY = _useSelector$statsDas.statsGatesForXY,
      dateTime = _useSelector$statsDas.dateTime,
      statsGatesXYSelected = _useSelector$statsDas.statsGatesXYSelected,
      zonesList = _useSelector.app.zonesList;

  var dispatch = useDispatch();
  var chartXY = useRef();
  var categoryAxis = useRef();
  useLayoutEffect(function () {
    chartXY.current = am4core.create('statsGatesXYChart', am4charts.XYChart);
    am4core.addLicense;
    chartXY.current.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chartXY.current.cursor = new am4charts.XYCursor(); // Create axes

    categoryAxis.current = chartXY.current.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.current.dataFields.category = 'gateName';
    categoryAxis.current.renderer.grid.template.location = 0;
    categoryAxis.current.renderer.minGridDistance = 0;
    categoryAxis.current.renderer.cellStartLocation = 0.2;
    categoryAxis.current.renderer.cellEndLocation = 0.8; // disable xAxes tooltip

    categoryAxis.current.cursorTooltipEnabled = false; // Configure axis label

    var label = categoryAxis.current.renderer.labels.template;
    label.truncate = false;
    label.maxWidth = 100; // label.tooltipText = "{category}"

    categoryAxis.current.events.on("sizechanged", function (ev) {
      var axis = ev.target;
      var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);

      if (cellWidth < axis.renderer.labels.template.maxWidth) {
        axis.renderer.labels.template.fontSize = 13;
        axis.renderer.labels.template.rotation = -45;
        axis.renderer.labels.template.horizontalCenter = "right";
        axis.renderer.labels.template.verticalCenter = "middle";
      } else {
        axis.renderer.labels.template.fontSize = 15;
        axis.renderer.labels.template.rotation = 0;
        axis.renderer.labels.template.horizontalCenter = "middle";
        axis.renderer.labels.template.verticalCenter = "top";
      }
    });
    var valueAxis = chartXY.current.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minGridDistance = 30;
    valueAxis.min = 0;
    valueAxis.cursorTooltipEnabled = false; // Set up series

    var series = chartXY.current.series.push(new am4charts.ColumnSeries());
    series.name = '進';
    series.dataFields.valueY = 'entryCount';
    series.dataFields.categoryX = "gateName";
    series.sequencedInterpolation = true;
    series.columns.template.strokeWidth = 0;
    series.columns.template.width = am4core.percent(100); // tooltip coordinate

    series.columns.template.tooltipX = am4core.percent(100);
    series.columns.template.tooltipY = am4core.percent(0);
    series.columns.template.adapter.add('tooltipText', function (text, target) {
      var _target$tooltipDataIt = target.tooltipDataItem.dataContext,
          entryCount = _target$tooltipDataIt.entryCount,
          exitCount = _target$tooltipDataIt.exitCount,
          gateName = _target$tooltipDataIt.gateName;
      target.tooltip.getFillFromObject = false;
      target.tooltip.background.fill = am4core.color("#000");
      var entryText = "\u9032: ".concat(entryCount);
      var exitText = "\u51FA: ".concat(exitCount);
      return "".concat(gateName, "\n").concat(entryText, "\n").concat(exitText);
    });
    var series2 = chartXY.current.series.push(new am4charts.ColumnSeries());
    series2.name = '出';
    series2.dataFields.valueY = 'exitCount';
    series2.dataFields.categoryX = "gateName";
    series2.sequencedInterpolation = true;
    series2.columns.template.strokeWidth = 0;
    series2.columns.template.width = am4core.percent(100); // series2.columns.template.tooltipText = `出: {valueY}`
    // Configure columns
    // series.columns.template.width = am4core.percent(60)
    // series.columns.template.tooltipText = `{valueY}${type==='termanal' ? '輛' : '分'}`
    // Add label

    var labelBullet = series.bullets.push(new am4charts.LabelBullet()); // labelBullet.label.text = "{valueY}"

    labelBullet.locationY = 0.5;
    labelBullet.label.hideOversized = true; // Add a legend

    chartXY.current.legend = new am4charts.Legend();
    chartXY.current.legend.position = 'right';
    chartXY.current.legend.maxWidth = '100';
    chartXY.current.legend.fontSize = '12';
    chartXY.current.data = _.map(statsGatesForXY, function (el) {
      return {
        gateName: el.gateName,
        entryCount: el.entryCount,
        exitCount: el.exitCount
      };
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chartXY.current.dispose();
    };
  }, [JSON.stringify(statsGatesForXY)]); // useEffect(() => {
  //     chartXY.current.data = _.map(statsGatesForXY, el => ({
  //         gateName: el.gateName,
  //         entryCount: el.entryCount,
  //         exitCount: el.exitCount
  //     }))
  //     categoryAxis.current.dispatch('sizechanged')
  // }, [JSON.stringify(statsGatesForXY)])

  var handleChange = function handleChange(zoneId) {
    dispatch(setStatsGatesXYSelected(zoneId));
    getStatsGates(contextRoot, false, zoneId, dateTime).then(function (data) {
      dispatch(setStatsGatesForXY(_.isEmpty(data.content) ? 'noData' : data.content));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "chart-dropdown"
  }, /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-terminals-center'),
    list: zonesList,
    value: statsGatesXYSelected,
    onChange: handleChange,
    width: "200px"
  })), statsGatesForXY === 'noData' ? /*#__PURE__*/React.createElement("div", {
    className: "stats-gates-xy-chart-nodata"
  }, t('lbl-no-data')) : /*#__PURE__*/React.createElement("div", {
    id: "statsGatesXYChart"
  }));
});
export default StatsGateXYChart;